import { useRef, useState } from "react";
import { ImagePlus, Loader2, Trash2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const photoSrc = (url) => (!url ? "" : url.startsWith("/api/") ? `${BACKEND}${url}` : url);

/** Pick a photo from the device (or paste a link) — used for vehicle photos. */
export const PhotoUpload = ({ value, onChange, label = "Photo", testId = "photo" }) => {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const pick = async (file) => {
    if (!file) return;
    setBusy(true); setError("");
    try {
      const body = new FormData();
      body.append("file", file);
      const { data } = await api.post("/uploads/image", body,
        { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
    } catch (e) { setError(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div>
      <label className="mb-2 block font-mono text-[11px] uppercase tracking-widest text-slate-500">{label}</label>
      <div className="flex items-center gap-3">
        {value ? (
          <img data-testid={`${testId}-preview`} src={photoSrc(value)} alt=""
            className="h-16 w-24 rounded-lg border border-ink-600 object-cover" />
        ) : (
          <span className="flex h-16 w-24 items-center justify-center rounded-lg border border-dashed border-ink-600 font-mono text-[10px] text-slate-600">
            no photo
          </span>
        )}
        <div className="flex flex-col gap-2">
          <button type="button" data-testid={`${testId}-upload`} disabled={busy}
            onClick={() => fileRef.current?.click()}
            className="flex items-center gap-2 rounded-full border border-ink-600 px-3 py-1.5 font-mono text-[11px] uppercase tracking-widest text-slate-300 transition-colors hover:border-gold/40 hover:text-gold">
            {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ImagePlus className="h-3.5 w-3.5" />}
            {value ? "Replace photo" : "Upload photo"}
          </button>
          {value && (
            <button type="button" data-testid={`${testId}-remove`} onClick={() => onChange("")}
              className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-slate-500 hover:text-red-400">
              <Trash2 className="h-3.5 w-3.5" /> Remove
            </button>
          )}
        </div>
      </div>
      <input ref={fileRef} type="file" accept="image/*" data-testid={`${testId}-input`} className="hidden"
        onChange={(e) => pick(e.target.files?.[0])} />
      <p className="mt-2 text-[11px] text-slate-600">JPG, PNG or WEBP up to 8 MB.</p>
      {error && <p data-testid={`${testId}-error`} className="mt-2 text-sm text-red-400">{error}</p>}
    </div>
  );
};
